import { z } from "zod";

const contactSchema = z.object({
  email: z.string().email("Invalid email format"),
  subject: z.string().min(3, "Subject must be at least 3 characters"),
  message: z.string().min(10, "Message must be at least 10 characters"),
});

export default contactSchema;
